import { X, CheckCircle, AlertCircle, Info } from 'lucide-react'
import { motion } from 'framer-motion'
import clsx from 'clsx'
import { useReducedMotion } from '../hooks/useReducedMotion'

interface ToastProps {
  message: string
  type: 'success' | 'error' | 'info'
  onClose: () => void
}

export default function Toast({ message, type, onClose }: ToastProps) {
  const prefersReducedMotion = useReducedMotion()

  const icons = {
    success: CheckCircle,
    error: AlertCircle,
    info: Info,
  }

  const Icon = icons[type]

  return (
    <motion.div
      initial={prefersReducedMotion ? false : { opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: -10, scale: 0.95 }}
      transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
      className={clsx(
        'toast',
        'flex items-center gap-3',
        'min-w-[280px] max-w-md'
      )}
      role="alert"
    >
      <Icon
        className={clsx(
          'w-5 h-5 flex-shrink-0',
          type === 'success' && 'text-green-500',
          type === 'error' && 'text-red-500',
          type === 'info' && 'text-blue-500'
        )}
      />
      <p className="flex-1 text-sm text-[var(--bbs-text-primary)]">{message}</p>
      <button
        onClick={onClose}
        className="flex-shrink-0 p-1 rounded hover:bg-[var(--luxury-glass-neutral)] transition-colors"
        aria-label="Close notification"
      >
        <X className="w-4 h-4 text-[var(--bbs-text-tertiary)]" />
      </button>
    </motion.div>
  )
}
